export default "__VITE_ASSET__nU91C$8$__"